import { StaticImageData } from 'next/image';

import backpackImage from '../_assets/backpack.jpg';
import balloonImage from '../_assets/balloon.jpg';
import blueberryImage from '../_assets/blueberry.jpg';
import butterflyImage from '../_assets/butterfly.jpg';
import carnivalImage from '../_assets/carnival.jpg';
import carrotImage from '../_assets/carrot.jpg';
import castleImage from '../_assets/castle.jpg';
import chickenImage from '../_assets/chicken.jpg';
import clockImage from '../_assets/clock.jpg';
import dinosaurImage from '../_assets/dinosaur.jpg';
import elephantImage from '../_assets/elephant.jpg';
import flowersImage from '../_assets/flowers.jpg';
import footballImage from '../_assets/football.jpg';
import forestImage from '../_assets/forest.jpg';
import libraryImage from '../_assets/library.jpg';
import oceanImage from '../_assets/ocean.jpg';
import pencilImage from '../_assets/pencil.jpg';
import planeImage from '../_assets/plane.jpg';
import playgroundImage from '../_assets/playground.jpg';
import princessImage from '../_assets/princess.jpg';
import racecarImage from '../_assets/racecar.jpg';
import rainbowImage from '../_assets/rainbow.jpg';
import sandwichImage from '../_assets/sandwich.jpg';
import scissorsImage from '../_assets/scissors.jpg';
import sneakerImage from '../_assets/sneakers.jpg';
import soccerImage from '../_assets/soccer.jpg';
import spaceshipImage from '../_assets/spaceship.jpg';
import starlightImage from '../_assets/starlight.jpg';
import trainImage from '../_assets/train.jpg';
import truckImage from '../_assets/truck.jpg';
import umbrellaImage from '../_assets/umbrella.jpg';
import xylophoneImage from '../_assets/xylophone.jpg';

export type WordGuessWord = {
  word: string;
  hint: string;
  image: StaticImageData | null;
  partOfSpeech: string;
  definition: string;
  secondaryDefinition?: string;
};

export const WORDS = [
  {
    word: 'PRINCESS',
    hint: 'A fairy tale character who wears a crown',
    image: princessImage,
    partOfSpeech: 'Noun',
    definition: 'A daughter of a king or queen, or the wife of a prince.',
  },
  {
    word: 'CASTLE',
    hint: 'Where royalty lives',
    image: castleImage,
    partOfSpeech: 'Noun',
    definition: 'A large, strong building where kings and queens live.',
  },
  {
    word: 'RAINBOW',
    hint: 'Appears after storms',
    image: rainbowImage,
    partOfSpeech: 'Noun',
    definition: 'A curved band of colors that appears in the sky when light shines through water droplets.',
  },
  {
    word: 'BUTTERFLY',
    hint: 'Starts as a caterpillar',
    image: butterflyImage,
    partOfSpeech: 'Noun',
    definition: 'A flying insect with large, often colorful wings.',
  },
  {
    word: 'TRUCK',
    hint: 'Drives on highways',
    image: truckImage,
    partOfSpeech: 'Noun',
    definition: 'A large vehicle used to carry heavy loads.',
  },
  {
    word: 'RACECAR',
    hint: 'Goes very fast',
    image: racecarImage,
    partOfSpeech: 'Noun',
    definition: 'A car built for racing at high speeds.',
  },
  {
    word: 'DINOSAUR',
    hint: 'Lived millions of years ago',
    image: dinosaurImage,
    partOfSpeech: 'Noun',
    definition: 'A reptile that lived on Earth millions of years before humans.',
  },
  {
    word: 'SOCCER',
    hint: 'Played by kicking a ball',
    image: soccerImage,
    partOfSpeech: 'Noun',
    definition: 'A sport where players kick a ball and try to score goals.',
  },
  {
    word: 'FOOTBALL',
    hint: 'Players wear helmets',
    image: footballImage,
    partOfSpeech: 'Noun',
    definition: 'A sport played with an oval ball on a field.',
  },
  {
    word: 'LIBRARY',
    hint: 'Full of books',
    image: libraryImage,
    partOfSpeech: 'Noun',
    definition: 'A place where you can borrow books to read.',
  },
  {
    word: 'SPACESHIP',
    hint: 'Flies to the stars',
    image: spaceshipImage,
    partOfSpeech: 'Noun',
    definition: 'A vehicle designed to travel through outer space.',
  },
  {
    word: 'FLOWERS',
    hint: 'Grows in gardens',
    image: flowersImage,
    partOfSpeech: 'Noun',
    definition: 'The colorful parts of plants that bloom.',
  },
  {
    word: 'TRAIN',
    hint: 'Runs on tracks',
    image: trainImage,
    partOfSpeech: 'Noun',
    definition: 'A vehicle that travels along railroad tracks.',
  },
  {
    word: 'SANDWICH',
    hint: 'A popular lunch food',
    image: sandwichImage,
    partOfSpeech: 'Noun',
    definition: 'Food made with bread and a filling in the middle.',
  },
  {
    word: 'BALLOON',
    hint: 'Floats at parties',
    image: balloonImage,
    partOfSpeech: 'Noun',
    definition: 'A rubber bag filled with air or helium that floats.',
  },
  {
    word: 'BACKPACK',
    hint: 'Worn to school',
    image: backpackImage,
    partOfSpeech: 'Noun',
    definition: 'A bag carried on your back for holding books and supplies.',
  },
  {
    word: 'UMBRELLA',
    hint: 'Keeps you dry in the rain',
    image: umbrellaImage,
    partOfSpeech: 'Noun',
    definition: 'A device used to protect yourself from rain.',
  },
  {
    word: 'ELEPHANT',
    hint: 'Never forgets',
    image: elephantImage,
    partOfSpeech: 'Noun',
    definition: 'A very large gray animal with a long trunk and big ears.',
  },
  {
    word: 'CLOCK',
    hint: 'Tells the time',
    image: clockImage,
    partOfSpeech: 'Noun',
    definition: 'A device that shows what time it is.',
  },
  {
    word: 'CARROT',
    hint: 'A vegetable that is good for your eyes',
    image: carrotImage,
    partOfSpeech: 'Noun',
    definition: 'A crunchy orange vegetable that grows underground.',
  },
  {
    word: 'BLUEBERRY',
    hint: 'Fruit that grows on a bush',
    image: blueberryImage,
    partOfSpeech: 'Noun',
    definition: 'A small, round, sweet blue fruit.',
  },
  {
    word: 'CHICKEN',
    hint: 'Says cluck cluck',
    image: chickenImage,
    partOfSpeech: 'Noun',
    definition: 'A farm bird that lays eggs and is raised for meat.',
  },
  {
    word: 'STARLIGHT',
    hint: 'Twinkles high above you',
    image: starlightImage,
    partOfSpeech: 'Noun',
    definition: 'The light that comes from stars in the night sky.',
    secondaryDefinition: 'Delivers Happiness to Kids',
  },
  {
    word: 'PLAYGROUND',
    hint: 'Has swings and slides',
    image: playgroundImage,
    partOfSpeech: 'Noun',
    definition: 'An outdoor area where children play on equipment like swings and slides.',
  },
  {
    word: 'CARNIVAL',
    hint: 'Rides and games',
    image: carnivalImage,
    partOfSpeech: 'Noun',
    definition: 'A fun fair with rides, games, and treats.',
  },
  {
    word: 'OCEAN',
    hint: 'Waves and whales',
    image: oceanImage,
    partOfSpeech: 'Noun',
    definition: 'A very large body of salt water.',
  },
  {
    word: 'AIRPLANE',
    hint: 'Flies in the sky',
    image: planeImage,
    partOfSpeech: 'Noun',
    definition: 'A vehicle with wings that flies through the air.',
  },
  {
    word: 'FOREST',
    hint: 'Full of trees',
    image: forestImage,
    partOfSpeech: 'Noun',
    definition: 'A large area covered with trees and plants.',
  },
  {
    word: 'XYLOPHONE',
    hint: 'A musical instrument',
    image: xylophoneImage,
    partOfSpeech: 'Noun',
    definition: 'A musical instrument with wooden bars that you hit with mallets.',
  },
  {
    word: 'PENCIL',
    hint: 'Used for writing',
    image: pencilImage,
    partOfSpeech: 'Noun',
    definition: 'A tool for writing or drawing, usually made of wood and graphite.',
  },
  {
    word: 'SCISSORS',
    hint: 'Cuts paper',
    image: scissorsImage,
    partOfSpeech: 'Noun',
    definition: 'A tool with two blades used for cutting paper and other materials.',
  },
  {
    word: 'SNEAKERS',
    hint: 'Worn on your feet',
    image: sneakerImage,
    partOfSpeech: 'Noun',
    definition: 'Comfortable shoes used for walking, running, or sports.',
  },
] as const satisfies readonly WordGuessWord[];
